import { render, staticRenderFns } from "./ReferralPopup.vue?vue&type=template&id=0ef3fa82"
import script from "./ReferralPopup.vue?vue&type=script&lang=js"
export * from "./ReferralPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports